/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { SelectV, ServiceSetComponent, InputV2, HeaderSection, BusinessList } from 'components';
import { useStyles } from './Style';
import { BUSINESS_EXCEPTIONS_SSO_ID } from 'config';
import { useBusiness } from 'hooks';
import { CalculationMethod } from './components';


const BaseInfo = (props) => {
  const classes = useStyles();

  const myBusiness = useBusiness();
  const methods = useFormContext();
  const { scType } = methods.watch();

  const paramsServiceSet = {
    pagination: { offset: 0, size: 15 },
  };

  return (
    <Grid container direction="row" alignItems="center" spacing={2} item xs={9}>
      <Grid item xs={4}>
        <InputV2
          fullWidth
          label="نام وب سرویس (فارسی)"
          errors={methods.formState.errors}
          name="scFaName"
          register={methods.register}
          rules={['required', 'isAlphaFa']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV2
          fullWidth
          label="نام وب سرویس (انگلیسی)"
          errors={methods.formState.errors}
          name="scEnName"
          register={methods.register}
          rules={['required', 'isAlphaEn']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV2
          label="نام سرویس دهنده"
          fullWidth
          errors={methods.formState.errors}
          name="scProvider"
          register={methods.register}
          rules={['required']}
          control={methods.control}
          tooltip="عنوان کسب‌وکار تعریف کننده سرویس. توجه کنید که این فیلد با فیلد ارائه دهنده سرویس متفاوت می‌باشد و صرفا عنوان کسب‌وکار وارد کننده سرویس را یادداشت کنید."
        />
      </Grid>

      <Grid item xs={12}>
        <InputV2
          label="توضیحات / معرفی کسب‌وکار"
          multiline
          fullWidth
          rows={5}
          errors={methods.formState.errors}
          name="description"
          register={methods.register}
          rules={['required']}
          control={methods.control}
        />
      </Grid>

      {/* مجموعه سرویس ها */}
      <Grid item xs={6}>
        <ServiceSetComponent
          errors={methods.formState.errors}
          control={methods.control}
          params={paramsServiceSet}
          required={false}
        />
      </Grid>
      {BUSINESS_EXCEPTIONS_SSO_ID.indexOf(myBusiness.ssoId) > -1 && (
        <Grid item xs={6}>
          <BusinessList
            label="ارائه دهنده سرویس"
            name="providerBusinessId"
            errors={methods.formState.errors}
            control={methods.control}
            tooltip="در این قسمت کسب‌وکار اصلی ارائه‌دهنده سرویس را جستجو و انتخاب کنید."
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <HeaderSection title="اطلاعات فنی" />
      </Grid>

      <Grid container item xs={10} alignItems="center">
        <Grid item xs={8}>
          <InputV2
            label="آدرس وب سرویس"
            fullWidth
            errors={methods.formState.errors}
            name="scUrl"
            register={methods.register}
            rules={['required', 'isURL']}
            control={methods.control}
            style={{ direction: 'ltr' }}
            hasMargin={false}
          />
        </Grid>
        <Grid item xs={2}>
          <SelectV
            name="scHttpVerb"
            showLabel
            label=" "
            options={[
              { value: 'DELETE', label: 'DELETE' },
              { value: 'GET', label: 'GET' },
              { value: 'POST', label: 'POST' },
              { value: 'PUT', label: 'PUT' },
              { value: 'OPTION', label: 'OPTION' },
            ]}
            control={methods.control}
            rules={['required']}
            className={classes.select}
            errors={methods.formState.errors}
            defaultValue="GET"
            fullWidth
            disabled={!(scType && scType === 'REST')}
          />
        </Grid>
      </Grid>

      <Grid item xs={2}>
        <InputV2
          fullWidth
          errors={methods.formState.errors}
          name="currentVersion"
          register={methods.register}
          rules={['required']}
          label="نسخه سرویس"
          control={methods.control}
        />
      </Grid>

      <Grid item xs={12}>
        <HeaderSection title="روش محاسبه قیمت" />
      </Grid>
      <CalculationMethod />
    </Grid>
  );
};

export default BaseInfo;
